<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

export default {
  name: 'App',
  components: {ElConfigProvider },
  data() {
    return {
      locale: zhCn
    }
  }
}
</script>

<style lang="scss">
@import "assets/css/reset.scss";
@import "assets/css/admin.scss";
//引入图标库及通用样式
@import 'assets/css/iconfont.css';
@import 'assets/css/common.scss';
</style>
